<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCInvestment :h2="this.h2" :h3="this.h3" deposit="true">
      <template v-slot:copy>
        <div>
          <div class="margin-bottom" @click="showPopup = true">
            <FCButton
              text="Click to View 2021 Season Ticket Reserved Seating Sections and Prices"
              wrapClass="wrapClass"
            />
          </div>
        </div>
        <div class="text-center margin-top">
          <a
            href="https://deposits.fccincinnati.com/events/2021%20reserved%20seat%20deposit/2020-12-31_19.30/fc%20cincinnati%20deposits?back=2&area=7a133315-3411-453c-ab26-41e4142dfcab&type=ga"
          >
            <FCButtonCTA text="Make Your Deposit" />
          </a>
        </div>
      </template>
    </FCInvestment>
    <FCPopup
      v-if="showPopup"
      title
      image="maps/reserved-seating-pricing.jpg"
      text
      @close-popup="showPopup = false"
    />
  </div>
</template>

<script>
/*
<a
            target="_blank"
            href="https://deposits.fccincinnati.com/events/2021 club deposit/2020-12-31_19.30/fc cincinnati deposits"
            @click="$gtag.event('begin_checkout', {'event_label': 'Pitch View Club'})"
          >
            <FCButtonCTA text="Claim your place" />
          </a>
          */
import FCInvestment from "@/components/patterns/FCInvestment";
import FCButtonCTA from "@/components/patterns/FCButtonCTA";
import FCButton from "@/components/patterns/FCButton";
import FCPopup from "@/components/patterns/FCShadowbox";
export default {
  components: {
    FCInvestment,
    FCButtonCTA,
    FCButton,
    FCPopup,
  },
  filters: {
    toCurrency: function (value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  mounted() {
    const ref = this.$store.state.menu.reservedSeating.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.reservedSeating.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.reservedSeating.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Reserved Seating",
      h3: "Claim Yours",
      seats: 1,
      price0: 325,
      price1: 391,
      price2: 425,
      price3: 550,
      price4: 600,
      price5: 750,
      price6: 825,
      price7: 900,
      showPopup: false,
    };
  },
  methods: {
    changeSeats(_modifier) {
      let _currentValue = this.seats;
      this.seats = Math.max(1, _currentValue + _modifier);
    },
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-reservedseating.jpg");
  background-size: cover;
  background-position: center;
}
</style>